require("!!/opt/build/repo/node_modules/script-loader/addScript.js")(require("!!/opt/build/repo/node_modules/raw-loader/index.js!/opt/build/repo/node_modules/ar.js/three.js/vendor/jsartoolkit5/build/artoolkit.min.js"))


//////////////////
// WEBPACK FOOTER
// ./node_modules/script-loader!./node_modules/ar.js/three.js/vendor/jsartoolkit5/build/artoolkit.min.js
// module id = 779
// module chunks = 0